export default __webpack_public_path__ + "static/media/38.3a826d96.svg";